import React from 'react';

import { useProfileRedirect } from '@neo.tax/onboarding/hooks';
import { TestimonialMemo, StyledSplitScreen } from '@neo.tax/onboarding/organisms';
import { Loader } from '@neo.tax/shared/organisms';

import { ProfileForm } from './organisms';

export const Profile = (): React.ReactElement => (
  <Loader useRedirect={useProfileRedirect}>
    <StyledSplitScreen leftSide={<ProfileForm />} rightSide={<TestimonialMemo />} />
  </Loader>
);
